// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { PageInfoFragment } from '../../../graphql/fragments/pageInfo.fragment.generated';
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../graphql/fragments/pageInfo.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DiagramArtifactsQueryVariables = Types.Exact<{
  householdID: Types.Scalars['ID']['input'];
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type DiagramArtifactsQuery = { __typename?: 'Query', paginatedData: { __typename?: 'DiagramArtifactConnection', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & PageInfoFragment
    ), edges?: Array<{ __typename?: 'DiagramArtifactEdge', node?: { __typename?: 'DiagramArtifact', id: string, name: string, updatedAt: Time, user: { __typename?: 'User', id: string, displayName: string } } | null } | null> | null } };

export const Operations = {
  Query: {
    DiagramArtifacts: 'DiagramArtifacts' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DiagramArtifactsDocument = gql`
    query DiagramArtifacts($householdID: ID!, $first: Int!, $after: Cursor) {
  paginatedData: diagramArtifacts(
    where: {householdID: $householdID}
    orderBy: [{field: updated_at, direction: DESC}]
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        name
        updatedAt
        user {
          id
          displayName
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useDiagramArtifactsQuery__
 *
 * To run a query within a React component, call `useDiagramArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagramArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagramArtifactsQuery({
 *   variables: {
 *      householdID: // value for 'householdID'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDiagramArtifactsQuery(baseOptions: Apollo.QueryHookOptions<DiagramArtifactsQuery, DiagramArtifactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagramArtifactsQuery, DiagramArtifactsQueryVariables>(DiagramArtifactsDocument, withFetchPolicyContext(options));
      }
export function useDiagramArtifactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagramArtifactsQuery, DiagramArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagramArtifactsQuery, DiagramArtifactsQueryVariables>(DiagramArtifactsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDiagramArtifactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiagramArtifactsQuery, DiagramArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiagramArtifactsQuery, DiagramArtifactsQueryVariables>(DiagramArtifactsDocument, withFetchPolicyContext(options));
        }
export type DiagramArtifactsQueryHookResult = ReturnType<typeof useDiagramArtifactsQuery>;
export type DiagramArtifactsLazyQueryHookResult = ReturnType<typeof useDiagramArtifactsLazyQuery>;
export type DiagramArtifactsSuspenseQueryHookResult = ReturnType<typeof useDiagramArtifactsSuspenseQuery>;
export type DiagramArtifactsQueryResult = Apollo.QueryResult<DiagramArtifactsQuery, DiagramArtifactsQueryVariables>;